<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>运营管理</el-breadcrumb-item>
            <el-breadcrumb-item>优惠券管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-row :gutter="0">
                <el-col :span="10">
                    <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
                        style="width:300px " @clear="getyouhuiquanList" @change="getyouhuiquanList">
                        <el-button slot="append" icon="el-icon-search" @click="getyouhuiquanList"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" @click="get_youhuiquan_add">添加优惠券</el-button>
                </el-col>
                <el-col :span="12"  style="text-align: right;" >
                    <el-button type="primary" @click="handleExport()">导出电子表格</el-button>
                </el-col>
            </el-row>
            <el-row :gutter="0" class="el_row_two">
                <el-col :span="24">
                    <el-table :data="youhuiquanList" style="width: 100%" border stripe id="report">
                        <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
                        <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
                        <el-table-column prop="name" label="优惠券名称"></el-table-column>
                        <el-table-column prop="mianzhi" label="优惠券面值"></el-table-column>
                        <el-table-column prop="faxing_count" label="发行数量"></el-table-column>
                        <el-table-column prop="yisong_count" label="已送数量"></el-table-column>
                        <el-table-column prop="expiry_day" label="发行有效期"></el-table-column>
                        <el-table-column prop="yong_flag" label="状态" width="130">
                            <template v-slot="scope">
                                <el-switch v-model="scope.row.yong_flag"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column prop="add_time" label="加入时间"></el-table-column>
                        <el-table-column label="操作">
                            <template v-slot="scope">
                                <el-tooltip class="item" effect="dark" content="查看详细" placement="top" :enterable="false">
                                    <el-button type="primary" icon="el-icon-arrow-right"
                                        @click="showEditDialog(scope.row.uid)" circle size="mini"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                                    <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                        @click="deleteForm(scope.row.uid)"></el-button>
                                </el-tooltip>

                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <!-- 分页 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
                <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
            </el-pagination>
            <!-- 添加优惠券部分 -->
            <el-dialog title="添加优惠券" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
                <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
                    <el-form-item label="优惠券编号" prop="youhuiquan_bianhao">
                        <el-input v-model="addForm.youhuiquan_bianhao" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="名称" prop="name">
                        <el-input v-model="addForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="面值" prop="mianzhi">
                        <el-input v-model.number="addForm.mianzhi" max="11" min="10"></el-input>
                    </el-form-item>
                    <el-form-item label="发行数量" prop="faxing_count">
                        <el-input v-model.number="addForm.faxing_count" max="11" min="10"></el-input>
                    </el-form-item>
                    <el-form-item label="可用天数" prop="faxing_count">
                        <el-input v-model.number="addForm.expiry_day" max="11" min="10"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addyouhuiquan" :disabled="add_isDisable">确 定</el-button>
                </span>
            </el-dialog>

            <el-dialog title="查看优惠券明细" :visible.sync="editDialogVisible" width="50%">
                <el-table :data="youhuiquanMingxiList" style="width: 100%" border stripe>
                    <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
                    <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
                    <el-table-column prop="bianhao" label="编号"></el-table-column>
                    <el-table-column prop="name" label="名称"></el-table-column>
                    <el-table-column prop="mianzhi" label="优惠券面值"></el-table-column>
                    <el-table-column prop="add_time" label="发行时间"></el-table-column>
                    <el-table-column prop="expiry_day" label="有效天数"></el-table-column>
                    <el-table-column  label="状态">
                        <template v-slot="scope">
                            {{ scope.row.song_flag===1?'已派送':'未派送' }}
                                <!-- <el-switch v-model=""></el-switch> -->
                            </template>

                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <el-pagination @size-change="mingxi_handleSizeChange" @current-change="mingxi_handleCurrentChange"
                    :current-page.sync="queryInfo_mingxi.pageNum" :page-sizes="[10, 50]"
                    :page-size="queryInfo_mingxi.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="mingxi_total">
                    <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
                </el-pagination>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="editDialogVisible = false">关闭窗口</el-button>

                </span>
            </el-dialog>

        </el-card>
    </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from '../../tongyong/config/validator';
import exportExcel from '../../tongyong/config/exportExcel'
export default {
    data() {
        return {

            // 获取用户列表参数
            queryInfo: {
                C_type: 'get_list',
                C_table_name: 'youhuiquan_list',
                query: '',
                pageNum: 1,
                pageSize: 10
            },
            queryInfo_mingxi: {
                C_type: 'get_list_more',
                C_table_name: 'youhuiquan_mingxi_list_more',
                query: '',
                pageNum: 1,
                pageSize: 10,
                CI_canshu01: 0
            },
            huifang_isDisable: false,
            add_isDisable: false,
            youhuiquanList: [],
            youhuiquanMingxiList: [],
            //  recordCount: 0,
            total: 0,
            mingxi_total: 0,
            addDialogVisible: false,
            editDialogVisible: false,
            huifangDialogVisible: false,

            addForm: {
                C_type: 'youhuiquan_add',
                youhuiquan_bianhao: '',
                name: '',
                mianzhi: 0,
                faxing_count: 0,
                expiry_day: 0
            },
            // 用于修改数据绑定
            editForm: {},
            // 表单规则项
            addFormRules: {
                name: [
                    { required: true, message: '请输入优惠券名称', trigger: 'blur' },
                    { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
                ],
                mianzhi: [
                    {
                        required: true,
                        message: '请输入数字'
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (!Number.isInteger(value) || value <= 0) {
                                callback(new Error('数字必须大于0'));
                            } else {
                                callback();
                            }
                        }
                    }

                ],
                faxing_count: [
                    {
                        required: true,
                        message: '请输入数字'
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (!Number.isInteger(value) || value <= 0) {
                                callback(new Error('数字必须大于0'));
                            } else {
                                callback();
                            }
                        }
                    }

                ]
            }
        };
    },
    created() {
        this.getyouhuiquanList();
    },
    methods: {
        handleExport() {
      exportExcel('report', '导出.xlsx')
    },
        get_switch_value(switchValue) {
            this.huifangForm.huifang_genjin = switchValue ? 1 : 0;
            console.log(this.huifangForm.huifang_genjin);
        },
        showEditDialog(uid) {
            this.getYouhuiquanMingxiList(uid);
            this.editDialogVisible = true;
        },
        async get_youhuiquan_add() {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_type: 'get_bianhao', C_table_type: 21 }
            });

            this.addForm.youhuiquan_bianhao = JSON.parse(res.data)[0].bianhao_l;
            // this.total = JSON.parse(res.data)[0].total
            this.addDialogVisible = true;
        },

        async getyouhuiquanList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            });
            // console.log(JSON.parse(res.data))
            this.youhuiquanList = JSON.parse(res.data)[0].dataList;

            if (!this.youhuiquanList) return;
            this.youhuiquanList.forEach(function (item) {
                item.yong_flag = item.yong_flag === 1;
            });

            this.total = JSON.parse(res.data)[0].total;

            // console.log(this.total)
        },
        async getYouhuiquanMingxiList(t) {
            if (t) this.queryInfo_mingxi.CI_canshu01 = t // 赋值批次序号
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo_mingxi
            });
            this.youhuiquanMingxiList = JSON.parse(res.data)[0].dataList;
            if (!this.youhuiquanMingxiList) return;
            this.mingxi_total = JSON.parse(res.data)[0].total;

            // console.log(this.total)
        },

        //  分页第一项下拉触发

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getyouhuiquanList();
        },
        // 选择页数触发
        handleCurrentChange(newPage) {
            this.queryInfo_mingxi.pageNum = newPage;
            this.getyouhuiquanList();
        },
        mingxi_handleSizeChange(newSize) {
            this.queryInfo_mingxi.pageSize = newSize;
            this.getYouhuiquanMingxiList();
        },
        // 选择页数触发
        mingxi_handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getYouhuiquanMingxiList();
        },
        async addyouhuiquan() {
            this.$refs.addFormRef.validate(async valid => {
                if (!valid) return 1;
                this.add_isDisable = true
                setTimeout(() => {
                    this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
                }, 2000)
                //    console.log(990, this.addForm)
                const { data: res } = await this.$http.post('api', this.addForm);
                console.log(JSON.parse(res.data)[0].status);
                if (JSON.parse(res.data)[0].status === 201) {
                    this.$message.error('重复')
                    return
                } else if ((JSON.parse(res.data)[0].status !== 200) && (JSON.parse(res.data)[0].status !== 201)) {
                    this.$message.error('添加失败')
                    return
                }
                this.$message.success('添加成功');
                this.getyouhuiquanList();
                this.addDialogVisible = false;
            });
        },

        addDoalogClosed() {
            this.$refs.addFormRef.resetFields();
        },
        // 删除一条记录
        async deleteForm(youhuiquanUid) {
            // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
            // 异步操作有2个，1个对话框等待，1个是网络请求
            const comfirmResult = await this.$confirm(
                '确定删除该条记录, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            console.log(comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
            const { data: res } = await this.$http.post('api', {
                C_type: 'record_delete',
                C_table_name: 'youhuiquan_del',
                C_data1: youhuiquanUid
            });
            if (JSON.parse(res.data)[0].status !== 200) {
                this.$message.error('删除失败');
                return;
            }
            this.$message.success('删除成功');
            this.getyouhuiquanList();
        }
    }
};
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
}
</style>
